<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $t('message.add') }} {{ $tc('message.reasons', 1) }}
                    </h3>
                </div>
            </div>

            <div class="card-body">
                <b-form @submit="onSubmit" @reset="onReset" v-if="show">

                    <b-form-group
                            id="dossier-group"
                            :label="$tc('message.generalConsultations', 1)"
                            label-for="dossier"
                    >
                        <b-form-input
                                id="dossier"
                                v-model="mFile"
                                disabled
                        ></b-form-input>

                    </b-form-group>

                    <b-form-group
                            id="reference-group"
                            :label="$t('message.reference')"
                            label-for="reference"
                            description=""
                    >
                        <b-form-input
                                id="reference"
                                v-model="$v.form.reference.$model"
                                :state="$v.form.reference.$dirty ? !(errorshasField('reference') || $v.form.reference.$error) : null"
                                required
                                placeholder=""
                                @focus="clearErrorField('reference')"
                        ></b-form-input>

                        <b-form-invalid-feedback v-if="!$v.form.reference.required">
                            {{ $t('message.requiredField') }}
                        </b-form-invalid-feedback>

                        <b-form-invalid-feedback v-else-if="errorshasField('reference')">
                            {{ getErrorsField('reference') }}
                        </b-form-invalid-feedback>
                    </b-form-group>

                    <b-form-group
                            id="description-group"
                            :label="$t('message.description')"
                            label-for="description">
                        <b-form-textarea
                                id="description"
                                v-model="$v.form.description.$model"
                                :state="$v.form.description.$dirty ? !(errorshasField('description') || $v.form.description.$error) : null"
                                rows="5"
                                required
                                placeholder=""
                                @focus="clearErrorField('description')"
                        ></b-form-textarea>

                        <b-form-invalid-feedback v-if="!$v.form.description.required">
                            {{ $t('message.requiredField') }}
                        </b-form-invalid-feedback>

                        <b-form-invalid-feedback v-else-if="errorshasField('description')">
                            {{ getErrorsField('description') }}
                        </b-form-invalid-feedback>
                    </b-form-group>
                    <b-container>
                        <b-row class="justify-content-center">
                            <b-button type="submit" variant="primary">
                                {{ $t('message.save') }}
                            </b-button>
                        </b-row>
                    </b-container>

                    <!--                    <b-button type="reset" variant="danger">-->
                    <!--                        {{ $t('message.reset') }}-->
                    <!--                    </b-button>-->
                </b-form>

                <b-table
                        id="reasons-table"
                        primary-key="id"
                        :per-page="perPage"
                        :current-page="currentPage"
                        selectable
                        select-mode="single"
                        borderless
                        responsive
                        striped
                        hover
                        :sort-by.sync="sortBy"
                        :sort-desc.sync="sortDesc"
                        @row-selected="rowSelected"
                        :fields="fields"
                        :items="mReasons"
                >
                    <!-- A virtual composite column for actions -->
                    <template slot="action" slot-scope="data" v-if="data.item.isAuthor || hasAdminRole">
                        <div class="row" v-if="data.item.isAuthor || hasAdminRole">
                            <div class="col-sm-6">
                                <b-link :to="{ name: 'edit-reason', params: { reason: data.item.slug } }">
                                    <i class="fas fa-edit fa-2x edit-icon"></i>
                                </b-link>
                            </div>

                            <div class="col-sm-6">
                                <i v-b-modal="'delete-modal-' + data.item.slug" class="fas fa-trash fa-2x delete-icon"></i>
                            </div>
                        </div>

                        <b-modal
                                :id="'delete-modal-' + data.item.slug"
                                size="sm"
                                header-bg-variant="danger"
                                header-text-variant="light"
                                :title="$t('message.delete') + ' ' + $tc('message.reasons', 1)"
                                hide-footer
                        >
                            <div class="d-block text-center">
                                <h3>{{ $t('message.delete') }} {{ data.item.reference }}?</h3>
                            </div>

                            <div class="d-block float-right">
                                <b-button class="secondary" @click="deleteReason(data.item.id,data.item.slug)">
                                    {{ $t('message.delete') }}
                                </b-button>

                                <b-button class="danger" @click="$bvModal.hide('delete-modal-' + data.item.slug)">
                                    {{ $t('message.cancel') }}
                                </b-button>
                            </div>
                        </b-modal>
                    </template>
                </b-table>

                <b-pagination
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                        aria-controls="reasons-table"
                ></b-pagination>

            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { required } from 'vuelidate/lib/validators';

    export default {
        name: "AddReason",

        computed: {
            ...mapGetters(["errors","generalConsultation",'hasAdminRole',
                'hasMedecinControleRole','hasAssistante',
                'hasPraticienRole',]),

            mFile: function() {
                if ((typeof this.generalConsultation.dossier == 'object') && (typeof this.generalConsultation.user == "object")) {
                    let dossier = this.generalConsultation.dossier;
                    let user = this.generalConsultation.user;
                    let fullName = user.prenom ? user.prenom : '' + (user.nom).toUpperCase();
                    let info = this.updateString(fullName) + " ( " + dossier.numero_dossier + " ) " + " " + this.generalConsultation.date_consultation;
                    return info;
                }
                return "";
            },

            mReasons:function(){
                let rArray = [];
                let self = this;
                if(typeof this.generalConsultation.motifs == 'object'){

                    _.forEach(this.generalConsultation.motifs, function(motif) {
                        let r = {};

                        r.reference = self.updateString(motif.reference);
                        r.description = self.updateString(motif.description);
                        r.slug = motif.slug;
                        r.isAuthor = motif.isAuthor;
                        r.id = motif.id;

                        rArray.push(r);
                    });

                }
                return rArray;
            },

            rows: function() {
                return this.mReasons.length;
            },
        },

        data() {
            return {
                perPage: 10,
                currentPage: 1,
                sortBy: 'date',
                sortDesc: true,
                fields: [
                    {
                        key: 'reference',
                        label: this.$i18n.t('message.reference'),
                    },
                    {
                        key: 'description',
                        label: this.$i18n.t('message.description'),
                        sortable: true
                    },
                    {
                        key: 'action',
                        label: this.$i18n.tc('message.operations', 1)
                    }
                ],
                consultation_id: this.$route.params.consultation,
                form: {
                    description: '',
                    reference: '',
                },
                show: true
            }
        },

        methods: {
            can: function (){
                if (this.hasAdminRole){
                    return true;
                }else{
                    return this.hasMedecinControleRole || this.hasPraticienRole || this.hasAssistante;
                }
            },

            getConsultation: function() {
                let args = {
                    consultation: this.consultation_id
                };
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                };

                this.$store.dispatch('getGeneralConsultation', { args, errorMessages });
            },
            updateString(value){
                if (value.length>25){
                    return (value.substring(0,25))+"..."
                }
                return  value;
            },
            onSubmit: function(evt) {
                evt.preventDefault();

                this.$v.$touch();

                if(!this.$v.$invalid) {
                    let args = {
                        consultation: this.consultation_id,
                        description: this.form.description,
                        reference: this.form.reference,
                    };

                    let successMessage = this.$i18n.t('message.reasonCreated');
                    let errorMessages = {
                        generic: this.$i18n.t('message.genericError'),
                        error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                    };

                    this.$store.dispatch('createConsultationReason', { args, errorMessages, successMessage })
                        .then(() => {
                            // Scroll to the top of the page
                            document.body.scrollTop = 0; // For Safari
                            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
                            this.$v.form.reference.$model = "";
                            this.form.description = " ";
                        });
                }
            },

            itemSelected(item) {
                this.$router.push({ name: 'reason', params: { reason: item.selectedObject.slug } });
            },

            rowSelected(items) {
                this.$router.push({ name: 'reason', params: { reason: items[0].slug } });
            },

            deleteReason(reason,slug) {
                let self = this;

                let args = {
                    consultation: self.generalConsultation.id,
                    motifs: reason
                };
                let successMessage = this.$i18n.t('message.reasonDeleted');
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.error')
                };

                this.$store.dispatch('deleteConsultationReason', { args, index: reason, successMessage, errorMessages })
                    .then(() => {
                        self.$bvModal.hide('delete-modal-' + slug);
                    });
            },

            onReset: function(evt) {
                evt.preventDefault();

                // Reset our form values
                this.form.description = '';
                this.form.reference = '';

                // Trick to reset/clear native browser form validation state
                this.show = false;

                this.$nextTick(() => {
                    this.show = true;
                });
            },

            getErrorsField(field){
                if (this.errorshasField(field)){
                    return this.errors[field][0];
                }else{
                    return  '';
                }
            },

            errorshasField(field){
                return this.errors ? this.errors.hasOwnProperty(field) : false;
            },

            clearErrorField(field){
                this.$store.dispatch('clearErrorField', { field });

                this.getErrorsField(field);
            }
        },

        validations: {
            form: {
                description: {
                    required
                },

                reference: {
                    //
                }
            }
        },

        mounted() {

            // Retrieve consultation
            this.getConsultation();
        }
    }
</script>

<style scoped>

</style>